module.exports = ".page {\n  width: 100%;\n  padding: 0 2.5rem;\n}\n\n.bold {\n  font-weight: 700;\n}\n\n.demoCopy {\n  font-size: 14px;\n}\n"